import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useState } from "react";

import TabSection, { TabSubSection } from "@/components/TabSection";
import { PatientEncounterChangeListener } from "@/pages/patient/patient";
import { PatientAllergies } from "@/components/Patient/PatientAllergies";
import PatientMedicalNotes from "@/components/Patient/PatientMedicalNotes";
import { PatientEncounter } from "@/resources/types";
import { Theme, css } from "@/theme";
import PatientInfoTab from "@/components/Patient/PatientInfoTab";
import PatientEncounters from "./PatientEncounters";

const styles = {
  container: css`
    border-radius: 1rem;
    padding-bottom: 1rem;
  `,
  tabPanel: css`
    background-color: #fafbff;
  `,
  heading: (theme: Theme) => css`
    background-color: ${theme.palette.primary[100]};
    border-radius: 1rem 1rem 0px 0px;
    color: ${theme.palette.primary[900]};
    padding: 0 2rem;
    margin-bottom: -0.25rem;

    .MuiTabs-flexContainer {
      gap: 2rem;
    }

    .MuiTab-root {
      padding: 0;
    }
  `,
};

type PatientTabsProps = {
  encounter: PatientEncounter;
  onEncounterChange: PatientEncounterChangeListener;
};

const PatientDetailsTabs = (props: PatientTabsProps) => {
  const [value, setValue] = useState(0);

  const { encounter, onEncounterChange } = props;

  const tabs = [
    {
      label: "Medical notes",
      component: (
        <PatientMedicalNotes
          onEncounterChange={onEncounterChange}
          encounter={encounter}
        />
      ),
    },
    {
      label: "Patient information",
      component: <PatientInfoTab encounter={encounter} />,
    },
    {
      label: "Allergies",
      component: <PatientAllergies encounter={encounter} />,
    },
    {
      label: "Previous Encounters",
      component: <PatientEncounters encounter={encounter} />,
    },
  ];

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <TabSection first>
      <Box css={styles.heading}>
        <Tabs value={value} onChange={handleChange}>
          {tabs.map((tab, index) => (
            <Tab disableRipple key={index} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      <TabSubSection>{tabs[value].component}</TabSubSection>
    </TabSection>
  );
};

export default PatientDetailsTabs;
